import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function loadCountries() {
	return (dispatch) => {
		dispatch(actions.countriesRequest());
		return server.getCountries().then((result) => dispatch(actions.countriesResponse(result)));
	};
}
